import React, { useState, useCallback } from 'react';
import { Tabs } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import StorageTab from './components/storageTab';
import MovesGrid from './components/movesGrid';
import InvoicesJournal from './components/invoicesJournal';
import ReferenceTab from './components/referenceTab';

const Materials = () => {
  const [dataVersion, setDataVersion] = useState(0);
  const [activeTabKey, setActiveTabKey] = useState('storage');

  const refreshData = useCallback(() => {
    setDataVersion((v) => v + 1);
  }, []);

  const items = [
    {
      key: 'storage',
      label: 'Хранение',
      children: <StorageTab dataVersion={dataVersion} onDataChange={refreshData} />,
    },
    {
      key: 'reference',
      label: 'Справочники',
      children: <ReferenceTab dataVersion={dataVersion} onDataChange={refreshData} />,
    },
    {
      key: 'journal',
      label: 'Журнал',
      children: (
        <MovesGrid dataVersion={dataVersion} onDataChange={refreshData} />
      ),
    },
    {
      key: 'invoices',
      label: 'Накладные',
      children: <InvoicesJournal dataVersion={dataVersion} onDataChange={refreshData} />,
    },
  ];

  return (
    <React.Fragment>
      <PageHeader
        title="Материалы"
        style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}
      />
      <Tabs
        activeKey={activeTabKey}
        onChange={setActiveTabKey}
        items={items}
      />
    </React.Fragment>
  );
};

export default Materials;
